import { gql } from 'urql'

export const queryAllPrincipleConfigs = gql`
  query {
    principle_config(order_by: [{ principle_config_name_locale: asc }, { id: asc }]) {
      id
      names
      active
    }
  }
`

export const queryPrincipleConfigsAndAggregateCount = gql`
  query ($offset: Int!, $limit: Int!) {
    principle_config(offset: $offset, limit: $limit, order_by: [{ principle_config_name_locale: asc }, { id: asc }]) {
      id
      principle_config_name_locale
      active
    }
    principle_config_aggregate {
      aggregate {
        count
      }
    }
  }
`

export const queryPrincipleConfigById = gql`
  query ($principleId: Int!) {
    principle_config(where: { id: { _eq: $principleId } }) {
      id
      names
      active
      help_and_instructions
      help_and_instruction_key
    }
  }
`

export const insertPrincipleConfig = gql`
  mutation ($principleInsertInput: [principle_config_insert_input!]!) {
    insert_principle_config(objects: $principleInsertInput) {
      affected_rows
    }
  }
`

export const updatePrincipleConfig = gql`
  mutation ($principleId: Int!, $principleSetInput: principle_config_set_input!) {
    update_principle_config(where: { id: { _eq: $principleId } }, _set: $principleSetInput) {
      affected_rows
    }
  }
`

export const updatePrincipleConfigAndRelatedSubprinciplesByPrincipleId = gql`
  mutation (
    $principleId: Int!
    $principleSetInput: principle_config_set_input!
    $subprincipleSetInput: subprinciple_config_set_input!
  ) {
    update_principle_config(where: { id: { _eq: $principleId } }, _set: $principleSetInput) {
      affected_rows
    }
    update_subprinciple_config(where: { principle_config_id: { _eq: $principleId } }, _set: $subprincipleSetInput) {
      affected_rows
    }
  }
`

export const queryPrinciplesSortedWithSubprinciplesSorted = gql`
  query {
    principle_config(where: { subprinciple_configs: { id: { _is_null: false } } }, order_by: { sort_number: asc }) {
      id
      names
      active
      sort_number
      subprinciple_configs(order_by: { sort_number: asc }) {
        active
        id
        names
        sort_number
      }
    }
  }
`

export const updateSortOnPrincipleConfig = gql`
  mutation (
    $firstWhere: principle_config_bool_exp!
    $secondWhere: principle_config_bool_exp!
    $setClause1: principle_config_set_input!
    $setClause2: principle_config_set_input!
  ) {
    updateFirst: update_principle_config(where: $firstWhere, _set: $setClause1) {
      affected_rows
    }

    updateSecond: update_principle_config(where: $secondWhere, _set: $setClause2) {
      affected_rows
    }
  }
`
